// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
// console.log('Vite ⚡️ Rails')

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>
// console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

// Example: Load Rails libraries in Vite.
//
// Turbo disabled: this is a Vue SPA where Vue Router handles navigation.
// Turbo was intercepting <a href> clicks in system messages (rendered via v-html),
// causing blank pages because it replaced the DOM without re-mounting the Vue app.
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
const channels = import.meta.glob('../../**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'







/* eslint no-console:0 */
import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import Vuetify from 'vuetify'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'vuetify/dist/vuetify.min.css'
import '../styles/global.css'
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

if (process.env.NODE_ENV == 'development') {
} else {
  Sentry.init({
      dsn: 'https://49606dfcd80e4e75840c4a295223364f@sentry.io/1519187',
      integrations: [new Integrations.Vue({Vue, attachProps: true})],
  });
}

import DatetimePicker from 'vuetify-datetime-picker'
// import 'vuetify-datetime-picker/src/stylus/main.styl'

import "core-js/stable";
import "regenerator-runtime/runtime";

import 'es6-promise/auto'

// Make lodash globally available
import _ from 'lodash';
window._ = _;

import vueMoment from 'vue-moment';

Vue.use(vueMoment)
Vue.use(Vuetify)
Vue.use(VueRouter)
Vue.use(DatetimePicker)

import store from '../store'
import router from '../router'

import VssApp from '../vss_app.vue'

Vue.mixin({
  methods: {
    navigateTo(routeName) {
      store.dispatch('global/navigateTo', routeName)
    },
    logout() {
      store.dispatch('userAuth/logout')
    },
  }
})

Vue.filter('phone', function (value) {
  return value.replace(/[^0-9]/g, '')
              .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
})

Vue.filter('decimalPlaces', function (value, digits) {
  if (!digits) {
    var digits = 2
  }
  return (Math.round(value * 100) / 100).toFixed(digits)
})

Vue.filter('placeholder', function(message, placeholder) {
  if (!placeholder) {
    var placeholder = 'Nothing here...'
  }
  if (!message) {
    return placeholder
  } else {
    return message
  }
})

Vue.filter('truncate', function (message, chars) {
  if (!chars) {
    var chars = 20
  }
  if ( message && message.length > chars ) {
    return `${ message.substring(0, chars - 2) }...`
  } else {
    return message
  }
})

import baseComponents from '../components/base'
baseComponents.forEach(component => {
  Vue.component(component.name, component)
})

// use a vue constructor
// make the call to check for login status the last item (don't let it return until
// it finishes)
// and guarantee that when that function returns, you KNOW the session state
// once you put that restriction in place, its a single point of failure

document.addEventListener('DOMContentLoaded', () => {
  const node = document.getElementById('vss-app')
  const vss_app = new Vue({
    store,
    router,
    beforeCreate() {
      // TODO: this next line needs to be in a promise..
      this.$store.dispatch('userAuth/getTokenFromStorage')
    },
    render: h => h(VssApp)
  }).$mount('#vss-app')
})
